import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CorporateActionStageLookup extends ValueObject {
    public corporateActionStageId: number = 0;

    public stageName: string = "";
}